export enum AudioPlayerTypeEnum {
  Full = 'full',
  PartialDesktop = 'partial-desktop',
  PartialTouch = 'partial-touch',
  Recorded = 'recorded',
  MP3 = 'mp3',
}
